import Partner from "../../../classes/Partner";
import * as React from "react";
import AppContext from "../AppContext";
import Section from "../Section/Section";
import { _t } from "../../../utils/Translator";
import api from "../../api";
import SaleOrder from "../../../classes/SaleOrder";

type SectionSaleOrdersProps = {
  partner: Partner;
  canCreatePartner: boolean;
};

type SectionSaleOrdersState = {
  saleOrders: SaleOrder[];
};

class SectionSaleOrders extends React.Component<SectionSaleOrdersProps, SectionSaleOrdersState> {
  constructor(props, context) {
    super(props, context);
    const saleOrders = this.props.partner.saleOrders;
    this.state = { saleOrders: saleOrders };
  }

  private getSaleOrderDescription = saleOrder => {
    return saleOrder.amount_total + " " + saleOrder.currency_id[1];
  };

  render() {
    return (
      <Section
        records={this.state.saleOrders}
        partner={this.props.partner}
        canCreatePartner={this.props.canCreatePartner}
        model="sale.order"
        odooEndpointCreateRecord={api.createSaleOrder}
        odooRecordIdName="saleOrder_id"
        odooRedirectAction="helpdesk_mail_plugin.helpdesk_ticket_action_form_edit"
        title="Sale Orders"
        titleCount="Sale Orders (%(count)s)"
        msgNoPartner="Save Contact to create new SaleOrders.."
        msgNoPartnerNoAccess="The Contact needs to exist to create SaleOrders."
        msgNoRecord="No saleOrders found for this contact."
        msgLogEmail="Log Email Into Sale Order"
        getRecordDescription={this.getSaleOrderDescription}
      />
    );
  }
}
SectionSaleOrders.contextType = AppContext;
export default SectionSaleOrders;
